// extracted by mini-css-extract-plugin
export default {"screen":"GoldScreenLayout_screen__385Xk","header":"GoldScreenLayout_header__cLW8f","logo":"GoldScreenLayout_logo__eoTh9","body":"GoldScreenLayout_body__EhwuA"};